import { render, staticRenderFns } from "./top-clubs.vue?vue&type=template&id=2572312c&"
import script from "./top-clubs.vue?vue&type=script&lang=js&"
export * from "./top-clubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports